export const USDollar = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export const Rwf = new Intl.NumberFormat(undefined, {
  style: 'currency',
  currency: 'Rwf',
});
